import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { HisNotificationService, HisAuthService, Language, HisNavigationService, HisBaseGlobalsService } from 'hisng';

import { PersonProfileEntryService } from '../../service/personprofile-entry.service';
import { PersonService } from '../../../common/service/person.service';
import { Person } from '../../../common/model/person/person';
import { PersonProfile } from '../../model/personprofile';

@Component({
    selector: 'psv-personprofile',
    templateUrl: './personprofile-edit-form.component.html',
    standalone: false
})
export class PersonProfileEditFormComponent implements OnInit {
    private hisAuthService = inject(HisAuthService);
    private personService = inject(PersonService);
    private personProfileEntryService = inject(PersonProfileEntryService);
    private notificationService = inject(HisNotificationService);
    private route = inject(ActivatedRoute);
    navigationService = inject(HisNavigationService);
    private hisBaseGlobalsService = inject(HisBaseGlobalsService);

    public person: Person;
    private personId: number;
    public personProfile: PersonProfile;
    public defaultLanguage: Language;
    public personProfileDataExist: boolean = false;

    ngOnInit(): void {
        this.route.params.subscribe( routeParams => {
            let personIdStr = routeParams['personId'];
            let parsedPersonId = personIdStr ? parseInt( personIdStr, 10 ) : null;
            if (parsedPersonId && !isNaN(parsedPersonId)) {
                this.personId = parsedPersonId;
            } else {
                this.personId = this.hisAuthService.personId;
            }
            this.loadData(this.personId);
            this.initPerson();
        } );
    }

    private async loadData(personId: number) {
        this.personProfileEntryService.getPersonProfileForPerson(personId).subscribe( (personProfile: PersonProfile) => {
            console.log('Loaded personProfile', personProfile);
            this.personProfile = personProfile;
            if(this.personProfile?.profileEntries.length) { this.personProfileDataExist = true;}
        } );
        this.defaultLanguage = new Language(12, 'deutsch');
    }

    private initPerson(): void {
        this.personService.getPersonById(this.personId).subscribe( (person: Person) => {
            this.person = person;
        });
    }

    public savePersonProfile(): void {
        console.log('save person profile', JSON.stringify(this.personProfile));
        this.personProfile.profileEntries.forEach(value => {
            if(value.entrytext === '<ul><li></li></ul>' || value.entrytext === '<ul><li><br></li></ul>'){
                value.entrytext = null;
            }
        } );
        this.personProfileEntryService.savePersonProfile(this.personId, this.personProfile).subscribe( savedProfile => {
            console.log('savedProfile =', savedProfile);
            this.personProfile = savedProfile;
            if(this.personProfile?.profileEntries.length) { this.personProfileDataExist = true;}
            this.notificationService.successI18n( 'cs.psv.person.profile.save.success' );
        } );
    }

    public isClassificationsPanelVisible() {
        const personProfileClassificationsActive = this.personProfile && !this.personProfile.employmentClassificationsDataSource;
        const employmentClassificationsActive = this.personProfile && this.personProfile.employmentClassificationsDataSource;
        const showSubjectAreas = this.hisBaseGlobalsService.getDd('cs.psv.person.profile.classification.subjectArea')?.hidden;
        const showResearchAreasKdsf = this.hisBaseGlobalsService.getDd('cs.psv.person.profile.classification.researchAreaKdsf')?.hidden;
        const showResearchAreas = this.hisBaseGlobalsService.getDd('cs.psv.person.profile.classification.researchArea')?.hidden;
        const showClassificationTab = showSubjectAreas && showResearchAreasKdsf && showResearchAreas;
        return !showClassificationTab && (personProfileClassificationsActive ||
            (employmentClassificationsActive && this.personProfile.employmentClassifications?.length));
    }

    public isMainDataVisible() {
        const showTeachingFields = this.hisBaseGlobalsService.getDd('cs.psv.person.profile.teachingFields')?.hidden;
        const showResearchFields = this.hisBaseGlobalsService.getDd('cs.psv.person.profile.researchFields')?.hidden;
        const showAboutMe = this.hisBaseGlobalsService.getDd('cs.psv.person.profile.aboutMe')?.hidden;
        const showMainData = showAboutMe && showResearchFields && showTeachingFields;
        return !showMainData;
    }
}
